import { render, staticRenderFns } from "./ddahistory.vue?vue&type=template&id=35ddce08&scoped=true"
import script from "./ddahistory.vue?vue&type=script&lang=js"
export * from "./ddahistory.vue?vue&type=script&lang=js"
import style0 from "./ddahistory.vue?vue&type=style&index=0&id=35ddce08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddce08",
  null
  
)

export default component.exports